const TreeNode = require('../TreeNode');
const UseAbility = require('../UseAbility');
const AICalc = require('../AICalc');
const BattleCalc = require('../../BattleCalc');
const Q_which_ranged_attack = require('./Q_which_ranged_attack');

const Q_target_high_hp = function (actor, battleState) {
  const node = new TreeNode(actor, battleState);

  node.YES = 'yes';
  node.NO = 'no';

  node.voidSpike = BattleCalc.getEquippedAbility(actor, 'void_spike');
  node.arrowShot = BattleCalc.getEquippedAbility(actor, 'arrow_shot');
  node.multiShot = BattleCalc.getEquippedAbility(actor, 'multi_shot');
  node.razorShot = BattleCalc.getEquippedAbility(actor, 'razor_shot');
  node.infectMind = BattleCalc.getEquippedAbility(actor, 'infect_mind');
  node.fumigate = BattleCalc.getEquippedAbility(actor, 'fumigate');
  node.lightning = BattleCalc.getEquippedAbility(actor, 'lightning');
  node.molotov = BattleCalc.getEquippedAbility(actor, 'molotov_cocktail');
  node.DAMAGE_DICT = {
    void_spike: node.voidSpike ? node.voidSpike.damage : 0,
    arrow_shot: node.arrowShot ? node.arrowShot.damage : 0,
    razor_shot: node.razorShot ? node.razorShot.potency : 0,
    multi_shot: node.multiShot ? node.multiShot.damage : 0,
    infect_mind: node.infectMind ? node.infectMind.potency : 0,
    fumigate: node.fumigate ? node.fumigate.potency : 0,
    lightning: node.lightning ? node.lightning.damage : 0,
    molotov_cocktail: node.molotov ? node.molotov.damage : 0,
  };

  node.branches[node.NO] = new Q_which_ranged_attack(actor, battleState);

  const originalDispose = node.dispose;
  node.dispose = function () {
    node.voidSpike = null;
    node.arrowShot = null;
    node.multiShot = null;
    node.razorShot = null;
    node.infectMind = null;
    node.fumigate = null;
    node.lightning = null;
    node.molotov = null;
    node.DAMAGE_DICT = null;
    node.bestDamageHandle = null;
    node.topDamage = null;
    originalDispose.call(node);
  };

  node.query = function (target) {
    if (!!(node.razorShot || node.infectMind || node.fumigate) && node.yesNoEvalFunction(target)) {
      // for ranged bleeds, try to spread DoTs to non-bleeding targets before applying new stacks
      target = AICalc.getBestDoTTarget(actor, target, battleState);

      return new UseAbility(actor, node.bestDamageHandle).query(target);
    } else {
      return node.branches[node.NO].query(target);
    }
  };

  node.yesNoEvalFunction = function (target) {
    const dot_potency = BattleCalc.getCombinedDoTPotency(target);
    if (dot_potency > target.hp * 0.333) return false;
    node.calculateTopDamage();
    return node.bestDamageHandle && target.hp > node.topDamage * 2.5;
  };

  node.calculateTopDamage = function () {
    node.bestDamageHandle = null;
    node.topDamage = 0;
    for (const [key, value] of Object.entries(node.DAMAGE_DICT)) {
      if (
        BattleCalc.getEquippedAbility(actor, key) &&
        value > node.topDamage &&
        (key === 'fumigate' ? AICalc.isAoESafe(actor, 'fumigate', actor, battleState, 1.5) : true)
      ) {
        node.topDamage = value;
        node.bestDamageHandle = key;
      }
    }
  };

  return node;
};
module.exports = Q_target_high_hp;
